import { ConversationSpamDetectionConfig } from '@pwp-common';

import { SpamDetectionConfigEditorOutput } from '../spam-detection-config-editor-output';

export const spamDetectionConfigEditorOutputToDb = (
  editorOutput: SpamDetectionConfigEditorOutput,
): ConversationSpamDetectionConfig =>
  new ConversationSpamDetectionConfig({
    enabled: editorOutput.enabled,
    instructions: editorOutput.instructions,
    spamDetectedMessage: editorOutput.spamDetectedMessage,
    spamFilteringPassedMessage: editorOutput.spamFilteringPassedMessage,
  });
